// extracted by mini-css-extract-plugin
export default {"container":"SubNavigation-container","scroll":"SubNavigation-scroll"};